import { render, staticRenderFns } from "./Etapa02.vue?vue&type=template&id=39af2808"
import script from "./Etapa02.vue?vue&type=script&lang=js"
export * from "./Etapa02.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports